// extracted by mini-css-extract-plugin
module.exports = {"shadow":"DataDetails_shadow__1y18b","dataDetailsWrapper":"DataDetails_dataDetailsWrapper__2zyQQ"};